/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-vars */
import React from "react";
import Button from "@mui/material/Button";
import { GridToolbarContainer } from "@mui/x-data-grid";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { styled } from "@mui/material/styles";
import "../TableToolbar.css";

const ToolbarButton = styled(Button)({
  fontFamily: "Poppins",
  fontSize: "14px",
  color: "#21357B",
  textTransform: "none",
});

const RefreshButton = styled(Button)({
  fontFamily: "Poppins",
  fontSize: "14px",
  color: "#21357B",
  textTransform: "none",
});

const ToolBarContainer = styled(GridToolbarContainer)({
  display: "flex",
  flexDirection: "row",
  width: "99%",
  justifyContent: "space-between",
});

function ReportsToolbar({ tabClicked, tab }) {
  return (
    <ToolBarContainer>
      <div>
        <ToolbarButton
          variant={tab === "employees" ? "outlined" : "text"}
          onClick={() => {
            tabClicked("employees");
          }}
        >
          Reports
        </ToolbarButton>
      </div>
      <div>
        <RefreshButton
          variant="text"
          name="refresh"
          onClick={() => {
            window.location.reload();
          }}
          startIcon={<AutorenewIcon />}
        >
          Refresh
        </RefreshButton>
      </div>
    </ToolBarContainer>
  );
}

export default ReportsToolbar;
